export const SET_CHATBOT_EXTERNAL_DATA = "SET_CHATBOT_EXTERNAL_DATA";
export const ADD_CHATBOT_MESSAGE = "ADD_CHATBOT_MESSAGE";
